import React from 'react';
import voxesLogo from './img/voxesLogo.svg';

export const Logo = () => {
    return (
        <img
            alt=""
            src={voxesLogo}
            width="30"
            height="30"
            className="d-inline-block align-top"
        />
    )
}